/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import styled from 'styled-components';
import {Collapsible, FontSizes, FontWeights, Text, minWidth} from '@calm-web/design-system';
import {FaqItem} from '../../../homepageRefresh/homepage/FAQ/styles';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(FaqItem, {
      $hideBorder: true,
      triggerTextColor: "bannerText",
      trigger: 'What is mindfulness?',
      children: [_jsx(_components.p, {
        children: "At its core, mindfulness is the practice of bringing focused attention to the present moment with an attitude of openness, curiosity, and non-judgment. It involves cultivating awareness of our thoughts, emotions, and the surrounding environment without getting caught up in them."
      }), _jsx(_components.p, {
        children: "Through mindfulness, we develop the ability to observe our thoughts, feelings, and sensations as they arise and pass away. This heightened awareness allows us to respond to life's challenges with clarity and compassion, rather than reacting impulsively."
      }), _jsx(_components.p, {
        children: "Mindfulness nurtures deeper connections with ourselves and others, fostering empathy and compassion. It can also reduce stress, anxiety, and depression, enhance focus and concentration, improve emotional regulation, and promote a greater sense of overall contentment."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What is meditation?',
      children: [_jsx(_components.p, {
        children: "Meditation is a practice that involves training the mind to focus and redirect its attention. It is a process of cultivating presence, awareness, and deep relaxation. Through meditation, we create a space within ourselves to explore the depths of who we are."
      }), _jsx(_components.p, {
        children: "Meditation offers an opportunity to observe our thoughts, emotions, and physical sensations without judgment. By gently guiding our attention to the present moment, we develop a heightened sense of awareness and gain insights into the patterns and fluctuations of our mind. This awareness allows us to respond to life's challenges with greater clarity and wisdom."
      }), _jsxs(_components.p, {
        children: ["It can also be a bit intimidating when starting out, which is why we offer a ", _jsx(_components.a, {
          href: "/app/program/qK3IeqhiJP",
          children: "7-day Meditation For Beginners"
        }), " program by Tamara Levitt, the Head of Mindfulness at Calm."]
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How do I practice mindfulness?',
      children: [_jsxs(_components.p, {
        children: ["The fact that you're asking this question already shows a curiosity for deeper awareness! One way to begin\npracticing mindfulness is by setting aside a dedicated time and space that feels peaceful and comfortable.\nStart with shorter sessions - all it takes is ", _jsx(_components.a, {
          href: "/app/player/0ADJHJs5a6",
          children: "5 minutes"
        }), ", gradually increasing the duration as you become\nmore comfortable. Experiment with different techniques to find the one that resonates with you the most. All\nyou really need is consistency and patience."]
      }), _jsx(_components.p, {
        children: "Remember, mindfulness is not limited to the time spent doing a\nformal meditation practice on a cushion or mat. It is about bringing the qualities of mindfulness and\npresence into every aspect of your life. This can be done by cultivating mindful moments throughout the day—\nsavoring a cup of tea, taking a mindful walk, or simply pausing to observe your breath."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What does meditation do?',
      children: [_jsx(_components.p, {
        children: "Meditation can have profound effects on your mental, emotional, and physical well-being. Studies show that a\nlong-term meditation practice can actually help shift your nervous system out of fight or flight and into\nthe relaxed parasympathetic mode, producing a wide array of benefits, including:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Decreased anxiety and depression symptoms"
        }), "\n", _jsx(_components.li, {
          children: "Chronic pain management"
        }), "\n", _jsx(_components.li, {
          children: "Lower stress levels"
        }), "\n", _jsx(_components.li, {
          children: "Improved sleep quality"
        }), "\n"]
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What is mindfulness meditation?',
      children: [_jsx(_components.p, {
        children: "Mindfulness meditation is a form of meditation that involves intentionally bringing focused attention to the\npresent moment with a non-judgmental and accepting attitude. It invites us to observe our thoughts,\nemotions, and physical sensations as they arise without getting caught up in them. Through cultivating\nmindful awareness, we deepen our connection to the present moment and gain insights into our mind and\nperception."
      }), _jsx(_components.p, {
        children: "By practicing mindfulness meditation, we learn to observe our thoughts and emotions without\nlabeling them as good or bad, right or wrong. This helps create space for self-compassion, self-discovery,\nand personal growth."
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
